import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import Header from "./Header";
import Feedstock from "../Components/Feedstock";
import axios, { AxiosRequestConfig } from "axios";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import ConfirmationModal from "../Components/Utils/ConfirmationModal";
import Modal from "react-modal";
import { v4 as uuidv4 } from "uuid";
import auth_guid from "../auth_guid.json"
import { useAdmin } from "../Utils/AdminContext";
import { ProjectApi } from "../Api/ProjectApi";
import QuestionnaireManagement from "../Components/QuestionnaireManagement";
interface ErrorMessage {
    field: string;
    message: string;
}
function UpdateQuestionnaire() {
    const [errors, setErrors] = useState<ErrorMessage[]>([]);
    const config =
        process.env.NODE_ENV === "production"
            ? require("../Config.prod").default
            : require("../Config.local").default;
    var scopeUrl =
        process.env.NODE_ENV === "production"
            ? "api://" + auth_guid.prod.tenantId + "/User.Read"
            : "https://CBEDevelopWebappTest.onmicrosoft.com/" + auth_guid.local.tenantId + "/User.Read";
    let { projectId } = useParams();
    const [isFormSubmitting, setIsFormSubmitting] = useState(false);
    const [dataProject, setDataProject] = useState(initProjectData);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isValidationErrorModalOpen, setIsValidationErrorModalOpen] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const navigate = useNavigate();
    const { instance, accounts } = useMsal();
    const [userToken, setuserToken] = useState<string | null>();
    const [isUpdateMessageVisible, setIsUpdateMessageVisible] = useState(false);
    const latestState = useRef(initProjectData);
    const latestValidationErrorState = useRef(errors);
    const [componentGuid, setComponentGuid] = useState<string>(uuidv4());
    const { isAdmin, setIsAdmin } = useAdmin();
    const api = new ProjectApi(accounts[0], instance);
    interface DropdownType {
        name: string;
        value: string[];
    }

    useEffect(() => {
        latestState.current = dataProject;
    }, [dataProject]);
    useEffect(() => {
        latestValidationErrorState.current = errors;
    }, [errors]);
    useEffect(() => {
        // const tabId = uuidv4();
        // console.log(tabId);
        // setComponentGuid(tabId);
    }, []);
    useEffect(() => {
        fetchData();

        if (dataProject.status == 1)
            window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            if (dataProject.status == 1)
                window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [projectId]);

    useEffect(() => {
        if (dataLoaded) {
            const now = new Date();
            const delay =
                (5 - (now.getMinutes() % 5)) * 60 * 1000 - now.getSeconds() * 1000;

            const timeout = setTimeout(() => {
                handleUpdate();
                // Ensuite, exécutez toutes les 5 minutes
                setInterval(handleUpdate, 5 * 60 * 1000);
            }, delay);
            return () => clearInterval(timeout);
        }
    }, [dataLoaded]);
    const fetchData = async () => {
        const response = await instance.acquireTokenSilent({
            scopes: [scopeUrl],
            account: accounts[0],
        });
        const axiosConfig = {
            headers: {
                Authorization: `Bearer ${response.accessToken}`,
            },
        };
        setuserToken(response.accessToken);
        console.log(componentGuid);
        axios
            .get(
                config.apiUrl +
                "/Project/GetProject?projectId=" +
                projectId +
                "&tabId=" +
                componentGuid,
                axiosConfig
            )
            .then((response) => {
                setDataProject(response.data);
                setDataProject((prevData) => {
                    return {
                        ...prevData,
                        tabId: componentGuid,
                    };
                });
                setDataLoaded(true);
                setIsAdmin(response.data.isAdmin);
                console.log(response.data)
            })
            .catch((error) => {
                navigate("/");
            });
    };
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
        disconnectUser();
        event.preventDefault();
        event.returnValue =
            "Are you sure you want to leave? you will loose all not saved data";
    };
    useEffect(() => {
        if (dataProject.status == 1)
            window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            if (dataProject.status == 1)
                window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [dataProject.status]);
    // #### FEEDSTOCK ####
    const handleAddFeedstock = () => {
        setDataProject((prevData) => {
            const updatedFeedstocks = [...prevData.feedstocks, newFeedstock];
            return { ...prevData, feedstocks: updatedFeedstocks };
        });
    };
    const handleDeleteFeedstock = (feedstockIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.feedstocks.splice(feedstockIndex, 1);
            return newData;
        });
    };
    const handleOnChangeFeedstock = (
        e: React.ChangeEvent<any>,
        feedstockIndex: number
    ) => {
        const { name, value, type, checked } = e.target;
        let updatedValue: boolean | number | string;

        switch (type) {
            case "checkbox":
                updatedValue = checked;
                break;
            case "radio":
                updatedValue = value === "true" ? true : false;
                break;
            default:
                updatedValue = value;
                break;
        }
        setDataProject((prevData) => {
            const updatedFeedstocks = [...prevData.feedstocks];
            updatedFeedstocks[feedstockIndex] = {
                ...updatedFeedstocks[feedstockIndex],
                [name]: updatedValue,
            };
            return {
                ...prevData,
                feedstocks: updatedFeedstocks,
            };
        });
    };

    // #### VALUE CHANGE ####
    const handleAddValueChain = () => {
        setDataProject((prevData) => {
            const updatedValueChains = [...prevData.valueChains, newValueChain];
            return { ...prevData, valueChains: updatedValueChains };
        });
    };
    const handleDeleteValueChain = (valueChainIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.valueChains.splice(valueChainIndex, 1);
            return newData;
        });
    };
    const handleOnChangeValueChain = (
        e: React.ChangeEvent<any>,
        valueChainIndex: number
    ) => {
        const { name, value, type, checked } = e.target;
        let updatedValue: boolean | number | string;

        switch (type) {
            case "checkbox":
                updatedValue = checked;
                break;
            case "radio":
                updatedValue = value === "true" ? true : false;
                break;
            default:
                updatedValue = value;
                break;
        }
        setDataProject((prevData) => {
            const updatedValueChains = [...prevData.valueChains];
            updatedValueChains[valueChainIndex] = {
                ...updatedValueChains[valueChainIndex],
                [name]: updatedValue,
            };
            return {
                ...prevData,
                valueChains: updatedValueChains,
            };
        });
    };

    // #### SMEs ####

    const handleAddSMEs = () => {
        setDataProject((prevData) => {
            const updatedSMEs = [...prevData.smEs, newSMEs];
            return { ...prevData, smEs: updatedSMEs };
        });
    };
    const handleDeleteSMEs = (smesIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.smEs.splice(smesIndex, 1);
            return newData;
        });
    };
    const handleOnChangeSMEs = (
        smesIndex: number,
        e?: React.ChangeEvent<any>,
        dropDown?: DropdownType
    ) => {
        let updatedValue: boolean | number | string | string[] | number[];
        var name: string;
        if (e !== undefined) {
            const { value, type, checked } = e.target;
            name = e.target.name;
            switch (type) {
                case "checkbox":
                    updatedValue = checked;
                    break;
                case "select-multiple":
                    const selectElement = e.target as HTMLSelectElement;
                    updatedValue = Array.from(selectElement.selectedOptions).map(
                        (option) => option.value
                    );

                    break;
                case "radio":
                    updatedValue = value === "true" ? true : false;
                    break;
                default:
                    updatedValue = value;
                    break;
            }
        } else if (dropDown !== undefined) {
            console.log(dropDown);
            name = dropDown.name;
            updatedValue = dropDown.value;
        } else {
            throw new Error("Must be defined");
        }
        setDataProject((prevData) => {
            const updatedsmEs = [...prevData.smEs];
            updatedsmEs[smesIndex] = {
                ...updatedsmEs[smesIndex],
                [name]: updatedValue,
            };
            return {
                ...prevData,
                smEs: updatedsmEs,
            };
        });
    };

    // #### PRIMARY PRODUCER ####
    const handleAddPrimaryProducer = () => {
        setDataProject((prevData) => {
            const updatedPrimaryProducers = [
                ...prevData.primaryProducers,
                newPrimaryProducer,
            ];
            return { ...prevData, primaryProducers: updatedPrimaryProducers };
        });
    };
    const handleDeletePrimaryProducer = (primaryProducerIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.primaryProducers.splice(primaryProducerIndex, 1);
            return newData;
        });
    };
    const handleOnChangePrimaryProducer = (
        outputIndex: number,
        e?: React.ChangeEvent<any>,
        dropDown?: DropdownType
    ) => {
        let updatedValue: boolean | number | string | string[] | number[];
        var name: string;
        if (e !== undefined) {
            const { value, type, checked } = e.target;
            name = e.target.name;
            switch (type) {
                case "checkbox":
                    updatedValue = checked;
                    break;
                case "select-multiple":
                    const selectElement = e.target as HTMLSelectElement;
                    updatedValue = Array.from(selectElement.selectedOptions).map(
                        (option) => option.value
                    );

                    break;
                case "radio":
                    updatedValue = value === "true" ? true : false;
                    break;
                default:
                    updatedValue = value;
                    break;
            }
        } else if (dropDown !== undefined) {
            console.log(dropDown);
            name = dropDown.name;
            updatedValue = dropDown.value;
        } else {
            throw new Error("Must be defined");
        }
        console.log(updatedValue);
        console.log(name);
        setDataProject((prevData) => {
            const updatedPrimaryProducer = [...prevData.primaryProducers];
            updatedPrimaryProducer[outputIndex] = {
                ...updatedPrimaryProducer[outputIndex],
                [name]: updatedValue,
            };
            return {
                ...prevData,
                primaryProducers: updatedPrimaryProducer,
            };
        });
    };

    // #### BIOWASTE MANAGER ####
    const handleAddBiowasteManager = () => {
        console.log("oaiefhjoih");
        setDataProject((prevData) => {
            const updatedBiowasteManagers = [
                ...prevData.biowasteManagers,
                newBiowasteManager,
            ];
            return { ...prevData, biowasteManagers: updatedBiowasteManagers };
        });
    };
    const handleDeleteBiowasteManager = (biowasteManagerIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.biowasteManagers.splice(biowasteManagerIndex, 1);
            return newData;
        });
    };

    const handleOnChangeBiowasteManager = (
        outputIndex: number,
        e?: React.ChangeEvent<any>,
        dropDown?: DropdownType
    ) => {
        let updatedValue: boolean | number | string | string[] | number[];
        var name: string;
        if (e !== undefined) {
            const { value, type, checked } = e.target;
            name = e.target.name;
            switch (type) {
                case "checkbox":
                    updatedValue = checked;
                    break;
                case "select-multiple":
                    const selectElement = e.target as HTMLSelectElement;
                    updatedValue = Array.from(selectElement.selectedOptions).map(
                        (option) => option.value
                    );

                    break;
                case "radio":
                    updatedValue = value === "true" ? true : false;
                    break;
                default:
                    updatedValue = value;
                    break;
            }
        } else if (dropDown !== undefined) {
            console.log(dropDown);
            name = dropDown.name;
            updatedValue = dropDown.value;
        } else {
            throw new Error("Must be defined");
        }
        setDataProject((prevData) => {
            const updatedBiowasteManager = [...prevData.biowasteManagers];
            updatedBiowasteManager[outputIndex] = {
                ...updatedBiowasteManager[outputIndex],
                [name]: updatedValue,
            };
            return {
                ...prevData,
                biowasteManagers: updatedBiowasteManager,
            };
        });
    };
    // #### BRAND OWNER ####
    const handleAddBrandOwner = () => {
        setDataProject((prevData) => {
            const updatedBrandOwners = [...prevData.brandOwner, newBrandOwner];
            return { ...prevData, brandOwner: updatedBrandOwners };
        });
    };
    const handleDeleteBrandOwner = (brandOwnerIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.brandOwner.splice(brandOwnerIndex, 1);
            return newData;
        });
    };
    const handleOnChangeBrandOwner = (
        brandOwnerIndex: number,
        e?: React.ChangeEvent<any>,
        dropDown?: DropdownType
    ) => {
        let updatedValue: boolean | number | string | string[] | number[];
        var name: string;
        if (e !== undefined) {
            const { value, type, checked } = e.target;
            name = e.target.name;
            switch (type) {
                case "checkbox":
                    updatedValue = checked;
                    break;
                case "select-multiple":
                    const selectElement = e.target as HTMLSelectElement;
                    updatedValue = Array.from(selectElement.selectedOptions).map(
                        (option) => option.value
                    );

                    break;
                case "radio":
                    updatedValue = value === "true" ? true : false;
                    break;
                default:
                    updatedValue = value;
                    break;
            }
        } else if (dropDown !== undefined) {
            console.log(dropDown);
            name = dropDown.name;
            updatedValue = dropDown.value;
        } else {
            throw new Error("Must be defined");
        }
        setDataProject((prevData) => {
            const updatedBrandOwner = [...prevData.brandOwner];
            updatedBrandOwner[brandOwnerIndex] = {
                ...updatedBrandOwner[brandOwnerIndex],
                [name]: updatedValue,
            };
            return {
                ...prevData,
                brandOwner: updatedBrandOwner,
            };
        });
    };

    // #### OUTPUT ####
    const handleAddOutput = () => {
        setDataProject((prevData) => {
            const updatedOutputs = [...prevData.outputs, newOutput];
            return { ...prevData, outputs: updatedOutputs };
        });
    };
    const handleDeleteOutput = (outputIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.outputs.splice(outputIndex, 1);
            return newData;
        });
    };
    const handleOnChangeOutput = (
        outputIndex: number,
        e?: React.ChangeEvent<any>,
        dropDown?: DropdownType
    ) => {
        let updatedValue: boolean | number | string | string[] | number[];
        var name: string;
        if (e !== undefined) {
            const { value, type, checked } = e.target;
            name = e.target.name;
            switch (type) {
                case "checkbox":
                    updatedValue = checked;
                    break;
                case "select-multiple":
                    const selectElement = e.target as HTMLSelectElement;
                    updatedValue = Array.from(selectElement.selectedOptions).map(
                        (option) => option.value
                    );

                    break;
                case "radio":
                    updatedValue = value === "true" ? true : false;
                    break;
                default:
                    updatedValue = value;
                    break;
            }
        } else if (dropDown !== undefined) {
            console.log(dropDown);
            name = dropDown.name;
            updatedValue = dropDown.value;
        } else {
            throw new Error("Must be defined");
        }
        console.log(updatedValue);
        console.log(name);
        setDataProject((prevData) => {
            const updatedOutputs = [...prevData.outputs];
            updatedOutputs[outputIndex] = {
                ...updatedOutputs[outputIndex],
                [name]: updatedValue,
            };
            return {
                ...prevData,
                outputs: updatedOutputs,
            };
        });
    };
    // #### IMPACTS ####

    const handleOnChangeImpacts = (
        e?: React.ChangeEvent<any>,
        dropDown?: DropdownType
    ) => {
        let updatedValue: boolean | number | string | string[] | number[];
        var name: string;
        if (e !== undefined) {
            const { value, type, checked } = e.target;
            name = e.target.name;
            switch (type) {
                case "checkbox":
                    updatedValue = checked;
                    break;
                case "radio":
                    updatedValue = value === "true" ? true : false;
                    break;
                case "select-multiple":
                    const selectElement = e.target as HTMLSelectElement;
                    updatedValue = Array.from(selectElement.selectedOptions).map(
                        (option) => option.value
                    );

                    break;
                default:
                    updatedValue = value;
                    break;
            }
        } else if (dropDown !== undefined) {
            console.log(dropDown);
            name = dropDown.name;
            updatedValue = dropDown.value;
        } else {
            throw new Error("Must be defined");
        }
        setDataProject((prevData) => ({
            ...prevData,
            impacts: {
                ...prevData.impacts,
                [name]: updatedValue,
            },
        }));
    };
    // #### MARKET ####

    const handleOnChangeMarket = (
        e?: React.ChangeEvent<any>,
        dropDown?: DropdownType
    ) => {
        let updatedValue: boolean | number | string | string[] | number[];
        var name: string;
        if (e !== undefined) {
            const { value, type, checked } = e.target;
            name = e.target.name;
            switch (type) {
                case "checkbox":
                    updatedValue = checked;
                    break;
                case "radio":
                    updatedValue = value === "true" ? true : false;
                    break;
                case "select-multiple":
                    const selectElement = e.target as HTMLSelectElement;
                    updatedValue = Array.from(selectElement.selectedOptions).map(
                        (option) => option.value
                    );

                    break;
                default:
                    updatedValue = value;
                    break;
            }
        } else if (dropDown !== undefined) {
            console.log(dropDown);
            name = dropDown.name;
            updatedValue = dropDown.value;
        } else {
            throw new Error("Must be defined");
        }
        setDataProject((prevData) => ({
            ...prevData,
            market: {
                ...prevData.market,
                [name]: updatedValue,
            },
        }));
    };
    // #### RDC ####
    const handleAddRDC = () => {
        setDataProject((prevData) => ({
            ...prevData,
            market: {
                ...prevData.market,
                rdcs: [...prevData.market.rdcs, newRDC],
            },
        }));
    };
    const handleDeleteRDC = (RDCIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.market.rdcs.splice(RDCIndex, 1);
            return newData;
        });
    };
    const handleOnChangeRDC = (e: React.ChangeEvent<any>, rdcIndex: number) => {
        const { name, value, type, checked } = e.target;
        let updatedValue: boolean | number | string | string[] | number[];

        switch (type) {
            case "checkbox":
                updatedValue = checked;
                break;
            case "radio":
                updatedValue = value === "true" ? true : false;
                break;
            default:
                updatedValue = value;
                break;
        }

        setDataProject((prevData) => {
            const updatedRDCs = [...prevData.market.rdcs];
            updatedRDCs[rdcIndex] = {
                ...updatedRDCs[rdcIndex],
                [name]: updatedValue,
            };

            return {
                ...prevData,
                market: {
                    ...prevData.market,
                    rdcs: updatedRDCs,
                },
            };
        });
    };
    // #### Technology ####

    const handleAddTechnology = () => {
        setDataProject((prevData) => {
            const updatedTechnology = [...prevData.technology, newTechnology];
            return { ...prevData, technology: updatedTechnology };
        });
    };
    const handleDeleteTechnology = (technologyIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.technology.splice(technologyIndex, 1);
            return newData;
        });
    };
    const handleOnChangeTechnology = (
        e: React.ChangeEvent<any>,
        technologyIndex: number
    ) => {
        const { name, value, type, checked } = e.target;
        let updatedValue: boolean | number | string;

        switch (type) {
            case "checkbox":
                updatedValue = checked;
                break;
            case "radio":
                updatedValue = value === "true" ? true : false;
                break;
            default:
                updatedValue = value;
                break;
        }
        setDataProject((prevData) => {
            const updatedTechnology = [...prevData.technology];
            updatedTechnology[technologyIndex] = {
                ...updatedTechnology[technologyIndex],
                [name]: updatedValue,
            };
            return {
                ...prevData,
                technology: updatedTechnology,
            };
        });
    };
    // #### INTERCONNCTIONS ####
    const handleAddInterconnection = () => {
        setDataProject((prevData) => {
            const updatedInterconnections = [
                ...prevData.interconnections,
                newInterconnection,
            ];
            return { ...prevData, interconnections: updatedInterconnections };
        });
    };
    const handleDeleteInterconnection = (interconnectionIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.interconnections.splice(interconnectionIndex, 1);
            return newData;
        });
    };
    const handleOnChangeInterconnection = (
        interconnectionIndex: number,
        e?: React.ChangeEvent<any>,
        dropDown?: DropdownType
    ) => {
        let updatedValue: boolean | number | string | string[] | number[];
        var name: string;
        if (e !== undefined) {
            const { value, type, checked } = e.target;
            name = e.target.name;
            switch (type) {
                case "checkbox":
                    updatedValue = checked;
                    break;
                case "select-multiple":
                    const selectElement = e.target as HTMLSelectElement;
                    updatedValue = Array.from(selectElement.selectedOptions).map(
                        (option) => option.value
                    );

                    break;
                case "radio":
                    updatedValue = value === "true" ? true : false;
                    break;
                default:
                    updatedValue = value;
                    break;
            }
        } else if (dropDown !== undefined) {
            console.log(dropDown);
            name = dropDown.name;
            updatedValue = dropDown.value;
        } else {
            throw new Error("Must be defined");
        }
        console.log(updatedValue);
        console.log(name);
        setDataProject((prevData) => {
            const updatedInterconnections = [...prevData.interconnections];
            updatedInterconnections[interconnectionIndex] = {
                ...updatedInterconnections[interconnectionIndex],
                [name]: updatedValue,
            };
            return {
                ...prevData,
                interconnections: updatedInterconnections,
            };
        });
    };

    // #### SDG ####
    // const handleAddsdg = () => {
    //   setDataProject((prevData) => {
    //     const updatedsdg = [...prevData.sdg, newsdg];
    //     return { ...prevData, sdg: updatedsdg };
    //   });
    // };
    // const handleDeletesdg = (sdgIndex: number) => {
    //   setDataProject((prevData) => {
    //     const newData = { ...prevData };
    //     newData.sdg.splice(sdgIndex, 1);
    //     return newData;
    //   });
    // };
    const handleOnChangesdg = (
        e?: React.ChangeEvent<any>,
        dropDown?: DropdownType
    ) => {
        let updatedValue: boolean | number | string | string[] | number[];
        var name: string;
        if (e !== undefined) {
            const { value, type, checked } = e.target;
            name = e.target.name;
            switch (type) {
                case "checkbox":
                    updatedValue = checked;
                    break;
                case "radio":
                    updatedValue = value === "true" ? true : false;
                    break;
                case "select-multiple":
                    const selectElement = e.target as HTMLSelectElement;
                    updatedValue = Array.from(selectElement.selectedOptions).map(
                        (option) => option.value
                    );

                    break;
                default:
                    updatedValue = value;
                    break;
            }
        } else if (dropDown !== undefined) {
            console.log(dropDown);
            name = dropDown.name;
            updatedValue = dropDown.value;
        } else {
            throw new Error("Must be defined");
        }
        setDataProject((prevData) => ({
            ...prevData,
            sdg: {
                ...prevData.sdg,
                [name]: updatedValue,
            },
        }));
    };

    // #### DIRECTIVE ####
    const handleAddDirective = () => {
        setDataProject((prevData) => ({
            ...prevData,
            market: {
                ...prevData.market,
                directives: [...prevData.market.directives, newCommunication],
            },
        }));
    };
    const handleDeleteDirective = (DirectiveIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.market.directives.splice(DirectiveIndex, 1);
            return newData;
        });
    };
    const handleOnChangeDirective = (
        e: React.ChangeEvent<any>,
        rdcIndex: number
    ) => {
        const { name, value, type, checked } = e.target;
        let updatedValue: boolean | number | string | string[] | number[];

        switch (type) {
            case "checkbox":
                updatedValue = checked;
                break;
            case "radio":
                updatedValue = value === "true" ? true : false;
                break;
            default:
                updatedValue = value;
                break;
        }

        setDataProject((prevData) => {
            const updatedDirectives = [...prevData.market.directives];
            updatedDirectives[rdcIndex] = {
                ...updatedDirectives[rdcIndex],
                [name]: updatedValue,
            };

            return {
                ...prevData,
                market: {
                    ...prevData.market,
                    directives: updatedDirectives,
                },
            };
        });
    };

    // #### COMMUNICATION ####
    const handleAddCommunication = () => {
        setDataProject((prevData) => ({
            ...prevData,
            market: {
                ...prevData.market,
                communications: [...prevData.market.communications, newCommunication],
            },
        }));
    };
    const handleDeleteCommunication = (CommunicationIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.market.communications.splice(CommunicationIndex, 1);
            return newData;
        });
    };
    const handleOnChangeCommunication = (
        e: React.ChangeEvent<any>,
        rdcIndex: number
    ) => {
        const { name, value, type, checked } = e.target;
        let updatedValue: boolean | number | string | string[] | number[];

        switch (type) {
            case "checkbox":
                updatedValue = checked;
                break;
            case "radio":
                updatedValue = value === "true" ? true : false;
                break;
            default:
                updatedValue = value;
                break;
        }

        setDataProject((prevData) => {
            const updatedCommunications = [...prevData.market.communications];
            updatedCommunications[rdcIndex] = {
                ...updatedCommunications[rdcIndex],
                [name]: updatedValue,
            };

            return {
                ...prevData,
                market: {
                    ...prevData.market,
                    communications: updatedCommunications,
                },
            };
        });
    };

    // #### Location ####

    const handleAddLocation = () => {
        setDataProject((prevData) => {
            const updatedLocation = [...prevData.locations, newLocation];
            return { ...prevData, locations: updatedLocation };
        });
    };
    const handleDeleteLocation = (locationIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.locations.splice(locationIndex, 1);
            return newData;
        });
    };
    const handleOnChangeLocation = (
        e: React.ChangeEvent<any>,
        locationIndex: number
    ) => {
        const { name, value, type, checked } = e.target;
        let updatedValue: boolean | number | string;

        switch (type) {
            case "checkbox":
                updatedValue = checked;
                break;
            case "radio":
                updatedValue = value === "true" ? true : false;
                break;
            default:
                updatedValue = value;
                break;
        }
        setDataProject((prevData) => {
            const updatedLocation = [...prevData.locations];
            updatedLocation[locationIndex] = {
                ...updatedLocation[locationIndex],
                [name]: updatedValue,
            };
            return {
                ...prevData,
                locations: updatedLocation,
            };
        });
    };

    // #### EuPolicy ####

    const handleAddEuPolicy = () => {
        setDataProject((prevData) => {
            const updatedeuPolicies = [...prevData.euPolicies, newEuPolicy];
            return { ...prevData, euPolicies: updatedeuPolicies };
        });
    };
    const handleDeleteEuPolicy = (euPolicyIndex: number) => {
        setDataProject((prevData) => {
            const newData = { ...prevData };
            newData.euPolicies.splice(euPolicyIndex, 1);
            return newData;
        });
    };
    const handleOnChangeEuPolicy = (
        e: React.ChangeEvent<any>,
        euPolicyIndex: number
    ) => {
        const { name, value, type, checked } = e.target;
        let updatedValue: boolean | number | string;

        switch (type) {
            case "checkbox":
                updatedValue = checked;
                break;
            case "radio":
                updatedValue = value === "true" ? true : false;
                break;
            default:
                updatedValue = value;
                break;
        }
        setDataProject((prevData) => {
            const updatedEuPolicies = [...prevData.euPolicies];
            updatedEuPolicies[euPolicyIndex] = {
                ...updatedEuPolicies[euPolicyIndex],
                [name]: updatedValue,
            };
            return {
                ...prevData,
                euPolicies: updatedEuPolicies,
            };
        });
    };

    // #### MARKET ####

    const handleOnChangeProjectDevelopment = (
        e?: React.ChangeEvent<any>,
        dropDown?: DropdownType
    ) => {
        let updatedValue: boolean | number | string | string[] | number[];
        var name: string;
        if (e !== undefined) {
            const { value, type, checked } = e.target;
            name = e.target.name;
            switch (type) {
                case "checkbox":
                    updatedValue = checked;
                    break;
                case "radio":
                    updatedValue = value === "true" ? true : false;
                    break;
                case "select-multiple":
                    const selectElement = e.target as HTMLSelectElement;
                    updatedValue = Array.from(selectElement.selectedOptions).map(
                        (option) => option.value
                    );

                    break;
                default:
                    updatedValue = value;
                    break;
            }
        } else if (dropDown !== undefined) {
            console.log(dropDown);
            name = dropDown.name;
            updatedValue = dropDown.value;
        } else {
            throw new Error("Must be defined");
        }
        setDataProject((prevData) => ({
            ...prevData,
            projectDevelopment: {
                ...prevData.projectDevelopment,
                [name]: updatedValue,
            },
        }));
    };
    const handleUpdateEditableTitle = (id: string, value: string) => {
        console.log('update editable title ' + id + value);
        setDataProject(prevData => ({
            ...prevData,
            customLabelValues: prevData.customLabelValues.map(item =>
                item.id === id ? { ...item, value: value } : item
            )
        }));
    }
    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleCloseValidationErrorModal = () => {
        setIsValidationErrorModalOpen(false);
    };
    const handleSubmit = async () => {
        setErrors([]);
        if (userToken == null) {
            const b2cResponse = await instance.acquireTokenSilent({
                scopes: [scopeUrl],
                account: accounts[0],
            });
            setuserToken(b2cResponse.accessToken);
        }
        const axiosConfig = {
            headers: {
                Authorization: `Bearer ${userToken}`,
            },
        };
        axios
            .post(config.apiUrl + "/Project/SubmitProject", dataProject, axiosConfig)
            .then((response) => {
                navigate("/");
            })
            .catch((error) => {
                setErrors([]);
                console.log(error.response);
                if (error.response && error.response.status === 400) {
                    if (Array.isArray(error.response.data)) {
                        setErrors(error.response.data);
                        setIsValidationErrorModalOpen(true);
                    } else {
                        if (error.response.data.errors && error.response.status === 400) {
                            const errors: ErrorMessage[] = Object.entries(
                                error.response.data.errors
                            ).map(([key, value]) => ({
                                field: key.split(".")[0],
                                message:
                                    typeof value === "object" && value !== null
                                        ? Object.values(value)[0]
                                        : "",
                            }));
                            Object.entries(error.response.data.errors).forEach(
                                ([cle, valeur]) => {
                                    console.log(`Clé: ${cle}, Valeur: ${valeur}`);
                                }
                            );
                            setErrors(errors);
                            setIsValidationErrorModalOpen(true);
                        }
                    }
                } else {
                    navigate("/");
                }
                handleCloseModal();
                console.log(errors);
            });
    };
    const disconnectUser = async () => {
        if (latestState.current.userRole != 3) {

            if (userToken == null) {
                const b2cResponse = await instance.acquireTokenSilent({
                    scopes: [scopeUrl],
                    account: accounts[0],
                });
                setuserToken(b2cResponse.accessToken);
            }
            const axiosConfig = {
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            };
            console.log(latestState.current.id);
            axios
                .post(
                    config.apiUrl + "/Project/DisconnectQuestionnaireLock",
                    { id: latestState.current.id },
                    axiosConfig
                )
                .then((response) => { })
                .catch((error) => { });
        }
    };

    const handleUpdate = async () => {
        console.log('in handle update')
        if (dataProject.userRole != 3 && dataProject.userRole != 4) {

            try {
                setIsFormSubmitting(true);
                const response = await api.updateQuestionnaire(latestState.current);

                setErrors(response.data);
                fetchData();

                setIsFormSubmitting(false);
                setIsUpdateMessageVisible(true);
                setTimeout(() => setIsUpdateMessageVisible(false), 2000);

            } catch (err) {
                setIsFormSubmitting(false);
                const error = err as { response?: { data?: { errors?: Record<string, unknown> }, status?: number } };

                if (error.response?.data?.errors && error.response.status === 400) {
                    const errors: ErrorMessage[] = Object.entries(error.response.data.errors)
                        .map(([key, value]) => ({
                            field: key.split(".")[0],
                            message: typeof value === "object" && value !== null ? Object.values(value)[0] : "",
                        }));
                    setErrors(errors);
                }
            }
        }
    };
    return (
        <>
            <Header
                projectName={dataProject.name}
                isUpdated={isUpdateMessageVisible}
                handleSubmit={handleOpenModal}
                handleUpdate={handleUpdate}
                userRole={dataProject.userRole}
                questionnaireState={dataProject.status}
                loaded={dataLoaded}
                isAdmin={isAdmin}
            />
            {dataLoaded ? (
                <QuestionnaireManagement
                    errors={errors}
                    data={dataProject}
                    handleUpdateEditableTitle={handleUpdateEditableTitle}
                    handleAddFeedstock={handleAddFeedstock}
                    handleDeleteFeedstock={handleDeleteFeedstock}
                    handleOnChangeFeedstock={handleOnChangeFeedstock}
                    handleAddValueChain={handleAddValueChain}
                    handleDeleteValueChain={handleDeleteValueChain}
                    handleOnChangeValueChain={handleOnChangeValueChain}
                    handleDeleteSMEs={handleDeleteSMEs}
                    handleOnChangeSMEs={handleOnChangeSMEs}
                    handleAddSMEs={handleAddSMEs}
                    handleAddPrimaryProducer={handleAddPrimaryProducer}
                    handleDeletePrimaryProducer={handleDeletePrimaryProducer}
                    handleOnChangePrimaryProducer={handleOnChangePrimaryProducer}
                    handleAddBiowasteManager={handleAddBiowasteManager}
                    handleDeleteBiowasteManager={handleDeleteBiowasteManager}
                    handleOnChangeBiowasteManager={handleOnChangeBiowasteManager}
                    handleAddBrandOwner={handleAddBrandOwner}
                    handleOnChangeBrandOwner={handleOnChangeBrandOwner}
                    handleDeleteBrandOwner={handleDeleteBrandOwner}
                    handleAddOutput={handleAddOutput}
                    handleDeleteOutput={handleDeleteOutput}
                    handleOnChangeOutput={handleOnChangeOutput}
                    handleOnChangeImpacts={handleOnChangeImpacts}
                    handleOnChangeMarket={handleOnChangeMarket}
                    handleAddRDC={handleAddRDC}
                    handleOnChangeRDC={handleOnChangeRDC}
                    handleDeleteRDC={handleDeleteRDC}
                    handleAddTechnology={handleAddTechnology}
                    handleOnChangeTechnology={handleOnChangeTechnology}
                    handleDeleteTechnology={handleDeleteTechnology}
                    handleAddInterconnection={handleAddInterconnection}
                    handleDeleteInterconnection={handleDeleteInterconnection}
                    handleOnChangeInterconnection={handleOnChangeInterconnection}
                    // handleAddsdg={handleAddsdg}
                    // handleDeletesdg={handleDeletesdg}
                    handleOnChangesdg={handleOnChangesdg}
                    handleAddDirective={handleAddDirective}
                    handleOnChangeDirective={handleOnChangeDirective}
                    handleDeleteDirective={handleDeleteDirective}
                    handleAddCommunication={handleAddCommunication}
                    handleOnChangeCommunication={handleOnChangeCommunication}
                    handleDeleteCommunication={handleDeleteCommunication}
                    handleAddLocation={handleAddLocation}
                    handleDeleteLocation={handleDeleteLocation}
                    handleOnChangeLocation={handleOnChangeLocation}
                    handleAddEuPolicy={handleAddEuPolicy}
                    handleDeleteEuPolicy={handleDeleteEuPolicy}
                    handleOnChangeEuPolicy={handleOnChangeEuPolicy}
                    handleOnChangeProjectDevelopment={handleOnChangeProjectDevelopment}
                    handleUpdate={handleUpdate}
                    handleSubmit={handleOpenModal}
                />
            ) : null}

            <ConfirmationModal
                isOpen={isModalOpen}
                onRequestClose={handleCloseModal}
                onConfirm={handleSubmit}
                title="Confirm Submission"
                message="Are you sure you want to submit this questionnaire?"
            />

            <Modal
                isOpen={isFormSubmitting}
                onRequestClose={() => { }}
                ariaHideApp={false}
                style={{
                    content: {
                        top: "50%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        marginRight: "-50%",
                        transform: "translate(-50%, -50%)",
                        width: "400px",
                        height: "200px",
                        padding: "20px",
                        borderRadius: "10px",
                        backgroundColor: "#ffffff", // Fond blanc
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#36458e", // Texte en bleu
                        textAlign: "justify",
                        textJustify: "inter-word",
                        margin: "auto",
                        marginLeft: 0,
                    },
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                    },
                }}
            >
                <div>Updating ... </div>
            </Modal>

            <Modal
                isOpen={isValidationErrorModalOpen}
                onRequestClose={handleCloseValidationErrorModal}
                ariaHideApp={false}
                style={{
                    content: {
                        top: "50%",
                        left: "50%",
                        right: "auto",
                        bottom: "auto",
                        marginRight: "-50%",
                        transform: "translate(-50%, -50%)",
                        width: "500px",
                        padding: "30px",
                        borderRadius: "10px",
                        backgroundColor: "#ffffff",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
                        color: "#36458e",
                    },
                    overlay: {
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                    },
                }}
            >
                <h2 style={{ color: "#d32f2f", marginBottom: "20px" }}>⚠️ Submission Not Possible</h2>
                <p style={{ fontSize: "16px", marginBottom: "20px" }}>
                    The questionnaire cannot be submitted because there are mandatory questions that remain unanswered.
                </p>
                <p style={{ fontSize: "14px", marginBottom: "20px", color: "#666" }}>
                    Please review the form and complete all required fields before attempting to submit again.
                </p>
                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                    <button onClick={handleCloseValidationErrorModal} className="big-button">
                        OK
                    </button>
                </div>
            </Modal>
        </>
    );
}

export default UpdateQuestionnaire;

const initProjectData = {
    tabId: "",
    userRole: 0,
    status: 0,
    name: "",
    id: "",
    isCBE: true,
    picNumbers: [],
    dropdownValues: [
        {
            tab: "",
            inputName: "",
            listValue: [],
        },
    ],
    customLabelValues: [
        {
            table: "",
            property: "",
            value: "",
            id: "",
        },
    ],
    tAndP: [
        {
            table: "",
            property: "",
            tooltip: "",
            placeholder: "",
            id: "",
        },
    ],
    feedstocks: [
        {
            typeOfFeedstock: "",
            typeOfFeedstockText: "",
            typeOfFeedstockSensitive: false,
            origin: "",
            originText: "",
            originSensitive: false,
            processedLocation: "",
            processedLocationText: "",
            processedLocationSensitive: false,
            isEnhancingBiodiversity: "",
            isEnhancingBiodiversityText: "",
            isEnhancingBiodiversitySensitive: false,
            zeroPollutionPractices: "",
            zeroPollution: false,
            reducingWaterConsumption: false,
            zeroPollutionPracticesText: "",
            zeroPollutionPracticesSensitive: false,
            mitigationOrAdaptationClimateChange: "",
            climateChangeMitigation: false,
            climateChangeAdaptation: false,
            mitigationOrAdaptationClimateChangeText: "",
            mitigationOrAdaptationClimateChangeSensitive: false,
        },
    ],
    valueChains: [
        {
            isCreatingOrEnablingNewValueChains: "",
            isCreatingOrEnablingNewValueChainsText: "",
            isCreatingOrEnablingNewValueChainsIsConfidential: false,
            noveltyOfTheFeedstock: "",
            noveltyOfTheFeedstockText: "",
            noveltyOfTheFeedstockSensitive: false,
            noveltyOfTheTechnologies: "",
            noveltyOfTheTechnologiesText: "",
            noveltyOfTheTechnologiesSensitive: false,
            noveltyOfTheMarkets: "",
            noveltyOfTheMarketsText: "",
            noveltyOfTheMarketsSensitive: false,
        },
    ],
    smEs: [
        {
            // ### SET 4.0 ###
            areSMEsInvolvedAsBeneficiaries: "",
            picNumber: "",
            category: [],
            otherTextBox: "",
            otherTextSensitive: false,

            // ### SET 4.1 ###
            b2bMultiple: [],
            b2bMultipleText: "",
            b2bMultipleSensitive: false,

            // ### SET 4.2 ###
            b2cMultiple: [],
            b2cMultipleText: "",
            b2cMultipleSensitive: false,
        },
    ],
    primaryProducers: [
        {
            arePrimaryProducersInvolved: "",

            beneficiaryPicList: "",

            engagedInValueChainsAtProjectLevelNotInConsortiumText: "",
            engagedInValueChainsAtProjectLevelNotInConsortiumSensitive: false,

            primarySectorOfActivity: "",
            primarySectorOfActivityText: "",
            primarySectorOfActivitySensitive: false,

            primaryActivitySpecificationText: "",
            primaryActivitySpecificationSensitive: false,
            projectRoles: [],
            projectRolesText: "",
            projectRolesSensitive: false,
        },
    ],
    biowasteManagers: [
        {
            areBiowasteManagersInvolved: "",

            beneficiaryPicList: "",

            engagedInValueChainsAtProjectLevelNotInConsortiumText: "",
            engagedInValueChainsAtProjectLevelNotInConsortiumSensitive: false,

            primarySectorOfActivity: "",
            primarySectorOfActivityText: "",
            primarySectorOfActivitySensitive: false,
            primaryActivitySpecificationText: "",
            primaryActivitySpecificationSensitive: false,

            projectRoles: [],
            projectRolesText: "",
            projectRolesSensitive: false,
        },
    ],
    brandOwner: [
        {
            // #### SET 1 ###
            bioBasedProductMarketEnhancement: "",

            brandOwnersPicList: "",

            numberOfBrandOwners: 0,
            numberOfBrandOwnersText: "",
            numberOfBrandOwnersSensitive: false,
        },
    ],
    outputs: [
        {
            // set0
            typeOfOutput: "",
            typeOfOutputText: "",
            typeOfOutputConfidential: false,

            // set1 CBE
            natureOfNoveltyBBI: "",
            natureOfNoveltyBBIText: "",
            natureOfNoveltyBBIConfidential: false,
            natureOfNoveltyCBE: "",
            natureOfNoveltyCBEText: "",
            natureOfNoveltyCBEConfidential: true,

            // set2
            typeOfBiobasedOutput: "",
            typeOfBiobasedOutputText: "",
            typeOfBiobasedOutputConfidential: false,
            // set3
            finalApplications: [],
            finalApplicationText: "",
            finalApplicationsConfidential: false,
            // set 4 bbi
            compositionOfFeedstocks: "",
            compositionOfFeedstocksText: "",
            compositionOfFeedstocksConfidential: false,
            // set 5 bbi
            environmentalPerformanceOutput: [],
            environmentalPerformanceOutputText: "",
            environmentalPerformanceOutputConfidential: false,
            // set 6 bbi
            economicPerformanceOutput: [],
            economicPerformanceOutputText: "",
            economicPerformanceOutputConfidential: false,
            // set 7 bbi
            productPerformanceOutput: [],
            productPerformanceOutputText: "",
            productPerformanceOutputConfidential: false,
            // set 4 cbe
            isProductImprovedLifeCycleEnvironmentalPerformance: "",
            isProductImprovedLifeCycleEnvironmentalPerformanceText: "",
            isProductImprovedLifeCycleEnvironmentalPerformanceConfidential: false,
            // set 5 cbe
            isProductCircular: "",
            productCircular: [],
            isProductCircularText: "",
            isProductCircularConfidential: false,
        },
    ],
    impacts: {
        // set 1 bbi cbe//set 1 BBI CBE
        numberJobs: 0,

        location: [],
        locationText: "",
        locationSensitive: false,

        typeJob: [],
        typeJobText: "",
        typeJobSensitive: false,

        numberJobsIndirect: 0,

        locationIndirect: [],
        locationIndirectText: "",
        locationIndirectSensitive: false,

        typeJobIndirect: [],
        typeJobIndirectText: "",
        typeJobIndirectSensitive: false,

        // set 2 cbe
        isContributingToDevSkillAndCapacity: "",
        isContributingToDevSkillAndCapacityText: "",
        isContributingToDevSkillAndCapacitySensitive: false,

        // set 4 cbe
        nRegionalHubs: null,
        nRegionalHubsText: "",
        nRegionalHubsSensitive: false,

        // set 5 cbe
        projectHasSynergies: "",

        hasSynergiesWithEU: [],
        hasSynergiesWithEUText: "",
        hasSynergiesWithEUSensitive: false,

        hasSynergiesWithNational: [],
        hasSynergiesWithNationalText: "",
        hasSynergiesWithNationalSensitive: false,

        hasSynergiesWithRegional: [],
        hasSynergiesWithRegionalText: "",
        hasSynergiesWithRegionalSensitive: false,

        // set 2 BBI
        scienceAndInnovation: [],
        scienceAndInnovationText: "",
        scienceAndInnovationSensitive: false,

        // set 3 BBI
        educationAndSociety: [],
        educationAndSocietyText: "",
        educationAndSocietySensitive: false,

        // set 4 BBI
        standardsRegulationsPolicies: [],
        standardsRegulationsPoliciesText: "",
        standardsRegulationsPoliciesSensitive: false,

        // set 5 BBI
        healthSafety: [],
        healthSafetyText: "",
        healthSafetySensitive: false,

        // set 6 BBI
        impactOnPrimaryProducers: [],
        impactOnPrimaryProducersText: "",
        impactOnPrimaryProducersSensitive: false,

        // set 7 BBI
        regionalAndLocalImpact: [],
        regionalAndLocalImpactText: "",
        regionalAndLocalImpactSensitive: false,

        // set 8 BBI
        environmentalImpact: [],
        environmentalImpactText: "",
        environmentalImpactSensitive: false,

        // set 9 BBI
        contributesBiodiversity: [],
        contributesBiodiversityText: "",
        contributesBiodiversitySensitive: false,
    },
    market: {
        contributions: [],
        contributionsText: "",
        contributionsSensitive: false,
        numberOfActionsToAttractInvestmentOrCreateAwareness: null,
        numberOfActionsToAttractInvestmentOrCreateAwarenessText: "",
        numberOfActionsToAttractInvestmentOrCreateAwarenessSensitive: false,
        relicableToOtherRegions: "",
        relicableToOtherRegionsText: "",
        relicableToOtherRegionsSensitive: false,
        rdcs: [
            {
                name: "",
                ticked: false,
                problems: "",
                solutions: "",
                updates: "",
                raisedProblemInECPublicConsultations: "",
                raisedProblemInECPublicConsultationsText: "",
            },
        ],

        directives: [
            {
                name: "",
                programs: "",
                problems: "",
                solutions: "",
                updates: "",
                raisedProblemInECPublicConsultations: "",
                raisedProblemInECPublicConsultationsText: "",
            },
        ],
        communications: [
            {
                name: "",
                programs: "",
                problems: "",
                solutions: "",
                updates: "",
                raisedProblemInECPublicConsultations: "",
                raisedProblemInECPublicConsultationsText: "",
            },
        ],
    },
    technology: [
        {
            // Set 1
            conversionProcess: "",
            conversionProcessText: "",
            conversionProcessSensitive: false,
            // Set 2
            trlStart: null,
            trlEnd: null,
        },
    ],
    locations: [
        {
            // Set 3
            country: "",
            countryFree: "",
            city: "",
            zipCode: "",
            address: "",
        },
    ],
    projectDevelopment: {
        // Set 4 cbe
        circularProcesses: "",
        circularProcessesText: "",
        circularProcessesSensitive: false,
        reduceGHG: "",
        reduceGHGText: "",
        reduceGHGSensitive: false,
        zeroWaste: "",
        zeroWasteText: "",
        zeroWasteSensitive: false,
        zeroPollution: "",
        zeroPollutionText: "",
        zeroPollutionSensitive: false,
        energyEfficiency: "",
        energyEfficiencyText: "",
        energyEfficiencySensitive: false,
    },
    interconnections: [
        {
            newInterconnection: "",
            newInterconnectionText: "",
            newInterconnectionSensitive: false,

            feedstock: "",
            feedstockText: "",
            feedstockSensitive: false,

            processingManufacturing: "",
            processingManufacturingText: "",
            processingManufacturingSensitive: false,

            endUsers: "",
            endUsersText: "",
            endUsersSensitive: false,
        },
    ],
    sdg: {
        contributions: [],
        contributionsText: "",
        contributionsSensitive: false,
    },
    euPolicies: [
        {
            initiative: "",
            initiativeText: "",
        },
    ],
};

const newBrandOwner = {
    // #### SET 1 ###
    bioBasedProductMarketEnhancement: "",

    brandOwnersPicList: "",

    numberOfBrandOwners: 0,
    numberOfBrandOwnersText: "",
    numberOfBrandOwnersSensitive: false,
};
const newTechnology = {
    // Set 1
    conversionProcess: "",
    conversionProcessText: "",
    conversionProcessSensitive: false,
    // Set 2
    trlStart: null,
    trlEnd: null,
};
const newLocation = {
    country: "",
    countryFree: "",
    city: "",
    zipCode: "",
    address: "",
};
const newFeedstock = {
    typeOfFeedstock: "",
    typeOfFeedstockText: "",
    typeOfFeedstockSensitive: false,
    origin: "",
    originText: "",
    originSensitive: false,
    processedLocation: "",
    processedLocationText: "",
    processedLocationSensitive: false,
    isEnhancingBiodiversity: "",
    isEnhancingBiodiversityText: "",
    isEnhancingBiodiversitySensitive: false,
    zeroPollutionPractices: "",
    zeroPollution: false,
    reducingWaterConsumption: false,
    zeroPollutionPracticesText: "",
    zeroPollutionPracticesSensitive: false,
    mitigationOrAdaptationClimateChange: "",
    climateChangeMitigation: false,
    climateChangeAdaptation: false,
    mitigationOrAdaptationClimateChangeText: "",
    mitigationOrAdaptationClimateChangeSensitive: false,
};
const newValueChain = {
    isCreatingOrEnablingNewValueChains: "",
    isCreatingOrEnablingNewValueChainsText: "",
    isCreatingOrEnablingNewValueChainsIsConfidential: false,
    noveltyOfTheFeedstock: "",
    noveltyOfTheFeedstockText: "",
    noveltyOfTheFeedstockSensitive: false,
    noveltyOfTheTechnologies: "",
    noveltyOfTheTechnologiesText: "",
    noveltyOfTheTechnologiesSensitive: false,
    noveltyOfTheMarkets: "",
    noveltyOfTheMarketsText: "",
    noveltyOfTheMarketsSensitive: false,
};
const newSMEs = {
    // ### SET 4.0 ###
    areSMEsInvolvedAsBeneficiaries: "",
    picNumber: "",
    category: [],

    otherTextBox: "",
    otherTextSensitive: false,
    // ### SET 4.1 ###
    b2bMultiple: [],
    b2bMultipleText: "",
    b2bMultipleSensitive: false,

    // ### SET 4.2 ###
    b2cMultiple: [],
    b2cMultipleText: "",
    b2cMultipleSensitive: false,
};
const newPrimaryProducer = {
    arePrimaryProducersInvolved: "",

    beneficiaryPicList: "",

    engagedInValueChainsAtProjectLevelNotInConsortiumText: "",
    engagedInValueChainsAtProjectLevelNotInConsortiumSensitive: false,

    primarySectorOfActivity: "",
    primarySectorOfActivityText: "",
    primarySectorOfActivitySensitive: false,

    primaryActivitySpecificationText: "",
    primaryActivitySpecificationSensitive: false,

    projectRoles: [],
    projectRolesText: "",
    projectRolesSensitive: false,
};
const newBiowasteManager = {
    areBiowasteManagersInvolved: "",

    beneficiaryPicList: "",

    engagedInValueChainsAtProjectLevelNotInConsortiumText: "",
    engagedInValueChainsAtProjectLevelNotInConsortiumSensitive: false,

    primarySectorOfActivity: "",
    primarySectorOfActivityText: "",
    primarySectorOfActivitySensitive: false,


    primaryActivitySpecificationText: "",
    primaryActivitySpecificationSensitive: false,

    projectRoles: [],
    projectRolesText: "",
    projectRolesSensitive: false,
};
const newOutput = {
    // set0
    typeOfOutput: "",
    typeOfOutputText: "",
    typeOfOutputConfidential: false,

    // set1 CBE
    natureOfNoveltyBBI: "",
    natureOfNoveltyBBIText: "",
    natureOfNoveltyBBIConfidential: false,
    natureOfNoveltyCBE: "",
    natureOfNoveltyCBEText: "",
    natureOfNoveltyCBEConfidential: true,

    // set2
    typeOfBiobasedOutput: "",
    typeOfBiobasedOutputText: "",
    typeOfBiobasedOutputConfidential: false,
    // set3
    finalApplications: [],
    finalApplicationText: "",
    finalApplicationsConfidential: false,
    // set 4 bbi
    compositionOfFeedstocks: "",
    compositionOfFeedstocksText: "",
    compositionOfFeedstocksConfidential: false,
    // set 5 bbi
    environmentalPerformanceOutput: [],
    environmentalPerformanceOutputText: "",
    environmentalPerformanceOutputConfidential: false,
    // set 6 bbi
    economicPerformanceOutput: [],
    economicPerformanceOutputText: "",
    economicPerformanceOutputConfidential: false,
    // set 7 bbi
    productPerformanceOutput: [],
    productPerformanceOutputText: "",
    productPerformanceOutputConfidential: false,
    // set 4 cbe
    isProductImprovedLifeCycleEnvironmentalPerformance: "",
    isProductImprovedLifeCycleEnvironmentalPerformanceText: "",
    isProductImprovedLifeCycleEnvironmentalPerformanceConfidential: false,
    // set 5 cbe
    isProductCircular: "",
    productCircular: [],
    isProductCircularText: "",
    isProductCircularConfidential: false,
};
const newInterconnection = {
    newInterconnection: "",
    newInterconnectionText: "",
    newInterconnectionSensitive: false,

    feedstock: "",
    feedstockText: "",
    feedstockSensitive: false,

    processingManufacturing: "",
    processingManufacturingText: "",
    processingManufacturingSensitive: false,

    endUsers: "",
    endUsersText: "",
    endUsersSensitive: false,
};
const newsdg = {
    contributions: [],
    contributionsText: "",
    contributionsSensitive: false,
};
const newRDC = {
    name: "",
    ticked: false,
    problems: "",
    solutions: "",
    updates: "",
    raisedProblemInECPublicConsultations: "",
    raisedProblemInECPublicConsultationsText: "",
};
const newCommunication = {
    name: "",
    programs: "",
    problems: "",
    solutions: "",
    updates: "",
    raisedProblemInECPublicConsultations: "",
    raisedProblemInECPublicConsultationsText: "",
};
const newEuPolicy = {
    initiative: "",
    initiativeText: "",
};
